import * as React from "react";
import { useState } from "react";
import styled from "@mui/material/styles/styled";
import { CircularProgress } from "@mui/material";
import { ChatElementsContainer } from "./chatElementsContainer";
import { QuestionsProgressBar } from "./questionsProgressBar";
import { scrollableStyle } from "fe-common/ui/commonStyles";
import { SkipConversationButton } from "./uiControllers/skipConversationButton";
import { PartialResultsDisclaimer } from "./Results/partialResultsDisclaimer";
import { usePatient } from "../state/patientContext";

//region [[ Styles ]]

const ChatElementsFrameView = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  height: "100%",
  position: "relative", // let children get 100% based on this
}));

const MasterLoader = styled("div")({
  height: "100%",
  width: "100%",
  display: "flex",
  position: "absolute",
  left: 0,
  top: 0,
  alignItems: "center",
  justifyContent: "center",
  margin: 0,
  background: "#FFFFFFA0",
  zIndex: 1500,
});

const ChatElements = styled(ChatElementsContainer)(() => ({
  flex: 2,
  ...scrollableStyle,
}));

const ProgressBar = styled(QuestionsProgressBar)(() => ({}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ChatElementsFrameProps {}

//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]

export const ChatElementsFrame = ({ ...props }: ChatElementsFrameProps) => {
  const [
    showPartialResultsDisclaimer,
    setShowPartialResultsDisclaimer,
  ] = useState(false);

  const { setAbandoned, masterLoading } = usePatient();

  const handleUserSkippedConversation = () => {
    setShowPartialResultsDisclaimer(false);
    setAbandoned(false);
  };

  return (
    <ChatElementsFrameView className={"frame-view"}>
      <ProgressBar />
      {masterLoading && (
        <MasterLoader>
          <CircularProgress size={80} />
        </MasterLoader>
      )}
      {!masterLoading && (
        <>
          <SkipConversationButton
            handleSkipConversation={() => setShowPartialResultsDisclaimer(true)}
          />
          <PartialResultsDisclaimer
            show={showPartialResultsDisclaimer}
            onClose={() => setShowPartialResultsDisclaimer(false)}
            onContinue={handleUserSkippedConversation}
          />
        </>
      )}
      <ChatElements />
    </ChatElementsFrameView>
  );
};
